/**
 * @package Ninja Forms
 * @subpackage Dashboard
 * @copyright (c) 2017 WP Ninjas
 * @since 3.2
 */
define( 'views/sections/memberships.js',[], function() {
    var view = Marionette.View.extend( {
        template: '#tmpl-nf-memberships'
    } );
    return view;
} );

